import { api } from "@api/api";

export async function deleteEndpointService(id: number): Promise<void> {
  await api.delete(`/v1/integration_endpoint_admin/${id}/`);
}
